module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAPpJREFUWIXtVtsNwjAMPGABRiiT4FEYxUwCm6Rs0k3gg0SNoih1bAOV6En+yMO+iy05Bjb8Ow4KHwIwALgBOMX16CWoRRoAPBeMP0HOFaIQrXbmKiInCHhnQiq0dbebnIU+hLlUwUJOCvIc5nKkV2gDEIylSM4WiEqxr+yxkTjhKrlUE9AVQADqFXB2Ih4lIloZ8BICNFp1TcBXUt8S0BVA4K96kEdfN8Vg2BpJ7q+Gtqff4fQzEvq/2XJmoCWH1kQ0AdhlQahYT5ino0skH7KzY9x/xLUJjOVpqJwZ8mwQHMDRyjSn6ahG4i5Cg1WJME1JVjB+mIEN68ULzP9zjLzRdEYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/img4.png
// module id = fb6z
// module chunks = 1